<template>
  <div class="band pushFooter">
    <div
      v-if="!gettingMetricsStatus && !metricsEnabled"
      class="bandContent mainPage dontPadExtra"
    >
      <div>
        <h2 data-automation="stats-disabled">
          Usage Stats Disabled
        </h2>
        <p>
          Please refer to the <a
            :href="docURL"
            target="_blank"
          >RStudio Package Manager Admin Guide</a>,  or contact an administrator to enable usage stats.
        </p>
      </div>
    </div>
    <div
      v-if="metricsEnabled"
      class="bandContent mainPage"
    >
      <div style="margin-bottom: 10px;">
        <span>
          Period:
          <select
            v-model.number="period"
            data-automation="stats-period-select"
          >
            <option value="30">
              Previous 30 days
            </option>
            <option value="90">
              Previous 90 days
            </option>
            <option value="365">
              Previous year
            </option>
          </select>
        </span>
        <span v-if="pypiEnabled">
          Ecosystem:
          <select
            v-model="sourceType"
            data-automation="stats-source-type-select"
          >
            <option value="r">
              R
            </option>
            <option
              value="pypi"
            >
              PyPI
            </option>
          </select>
        </span>
      </div>
      <div class="section">
        <div class="splitColumns withMobileMargins">
          <div class="column50">
            <StatsDownloadsChart
              :period="period"
              :source-type="sourceType"
            />
          </div>
          <div class="column50">
            <StatsUniqueDownloadsChart
              :period="period"
              :source-type="sourceType"
            />
          </div>
        </div>
        <div class="splitColumns withMobileMargins">
          <div class="column50">
            <StatsPackages
              :period="period"
              :source-type="sourceType"
            />
          </div>
          <div class="column50">
            <StatsLicenses
              :period="period"
              :source-type="sourceType"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import * as types from '../store/mutation-types'
import { serverPath } from '../api/http-common'
import StatsDownloadsChart from './StatsDownloadsChart'
import StatsUniqueDownloadsChart from './StatsUniqueDownloadsChart'
import StatsLicenses from './StatsLicenses'
import StatsPackages from './StatsPackages'
import { REPO_TYPE_PYTHON } from '../constants/repo-types'

export default {
  name: 'Stats',
  components: {
    StatsDownloadsChart,
    StatsUniqueDownloadsChart,
    StatsLicenses,
    StatsPackages,
  },
  computed: {
    ...mapState({
      metricsEnabled: state => state.status.metricsEnabled,
      gettingMetricsStatus: state => state.status.gettingMetricsStatus,
      gotRepos: state => state.repos.gotRepos,
      allRepos: state => state.repos.allRepos,
    }),
    docURL: function () {
      return `${serverPath()}__docs__/admin`
    },
    period: {
      get () { return this.$store.state.stats.period },
      set (value) { this.$store.commit(types.SET_STATS_PERIOD, value) },
    },
    sourceType: {
      get () { return this.$store.state.stats.sourceType },
      set (value) { this.$store.commit(types.SET_STATS_SOURCE_TYPE, value) },
    },
    pypiEnabled: function () {
      return this.allRepos.filter(repo => repo.type === REPO_TYPE_PYTHON).length > 0
    },
  },
  created: function () {
    if (!this.gotRepos) {
      this.$store.dispatch('getAllRepos', 0)
    } else {
      this.setRepoId({ repoId: undefined })
    }
    this.$store.commit(types.SET_MENU_ITEMS, { menuItems: [] })
    this.$store.commit(types.SET_SHRINK_HEADER, true)
    this.$store.commit(types.SET_SHOW_FOOTER, true)
    this.$store.commit(types.SET_NAV_TOGGLER_AS_NEEDED, false)
    this.$store.commit(types.SET_HEADER_TITLE, 'Usage Stats')
  },
  methods: {
    ...mapActions([
      'setRepoId',
    ]),
  },
}
</script>
